var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div'),_vm._v(" "),_c('d1-vue-component',{ref:"basicComponent",attrs:{"options":_vm.generateOption,"dataFacetKey":_vm.dataFacetKey,"d1CoreBaseUrl":_vm.baseD1Url},on:{"handleTableValueClick":_vm.handleTableValueClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bfaebe2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/store/banner_master/banner_operation_log.vue
// module id = null
// module chunks = 